export default __webpack_public_path__ + "static/media/map-directions.inline.efcfcc8a.svg";